// Initialize window.gc with safe defaults when the backend doesn't inject it
// (e.g., when running the Vite dev server standalone without Docker).
// Uses a shallow merge so backend-injected values are preserved while
// missing properties get filled in with defaults.
const defaults = {
  config: { ga4_id: "", ga_id: "" },
  api_key: import.meta.env.VITE_API_KEY || "gck_7a815cb03656425cbd2b42a8523582ae",
  api_url: import.meta.env.VITE_API_URL || "",
  assets_url: import.meta.env.VITE_ASSETS_URL || "https://secure-assets.gcdev.site",
  stripe_key: "",
  environment: "development",
  mixpanel_project_id: "",
  stripeCiWidget: false,
  stripeOnAllPages: false,
};

window.gc = window.gc || ({} as Window["gc"]);
window.gc.global = { ...defaults, ...window.gc.global };

// Stub gtag if not loaded (e.g., no Google Analytics script in standalone dev)
if (!window.gtag) {
  window.gtag = (() => {}) as Gtag.Gtag;
}
